<div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" *ngIf="isLoading | async">
  <div class="bg-white rounded-xl shadow-xl px-6 py-5 max-w-sm mx-4 w-full text-center">
    <img
      *ngIf="showBrandLogo | async"
      src="assets/imgs/logo-la-soberania-2.png"
      alt="La Soberania de Seguros"
      class="h-16 mx-auto mb-4"
    />

    <p class="text-[#1b3a8a] font-semibold leading-6" *ngIf="(message | async) as msg; else defaultDots">
      {{ msg }}
    </p>

    <ng-template #defaultDots>
      <div class="flex justify-center space-x-2">
        <div class="w-2 h-2 bg-[#1b3a8a] rounded-full animate-bounce delay-0"></div>
        <div class="w-2 h-2 bg-[#1b3a8a] rounded-full animate-bounce delay-200"></div>
        <div class="w-2 h-2 bg-[#1b3a8a] rounded-full animate-bounce delay-400"></div>
      </div>
    </ng-template>
  </div>
</div>
